import CheckboxField from 'components/forms/checkboxField/CheckboxField';
import FormWithProvider from 'components/forms/form/Form';
import FieldPlaceholder from 'pages/property/common/FieldPlaceholder';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import SendOwnerInviteModalFooter from './SendOwnerInviteModalFooter';
import { SendOwnerInviteModalFieldsetStyled } from './SendOwnerInviteModal.styles';

interface SendOwnerInviteModalLoadingPlaceholderProps {
  onClose: () => void;
}

const SendOwnerInviteModalLoadingPlaceholder = ({
  onClose,
}: SendOwnerInviteModalLoadingPlaceholderProps) => {
  const { t } = useTranslation();
  return (
    <FormWithProvider horizontal onSubmit={() => {}}>
      <Modal.Header closeButton>
        <Modal.Title>{t('pageProperty.owners.inviteModal.title')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <SendOwnerInviteModalFieldsetStyled>
          <FieldPlaceholder
            colSmInput={10}
            colSmLabel={2}
            disabled
            label={t('common.to')}
            name="to"
          />

          <FieldPlaceholder
            colSmInput={10}
            colSmLabel={2}
            label={t('common.subject')}
            name="subject"
          />

          <FieldPlaceholder
            colSmInput={12}
            colSmLabel={0}
            linesCount={32.5}
            name="subject"
          />

          <CheckboxField name="sendCopyToAgency" disabled>
            {t('pageProperty.owners.inviteModal.sendCopyToAgency')}
          </CheckboxField>
        </SendOwnerInviteModalFieldsetStyled>
      </Modal.Body>

      <SendOwnerInviteModalFooter isLoading onClose={onClose} />
    </FormWithProvider>
  );
};

export default SendOwnerInviteModalLoadingPlaceholder;
